import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getLearningPlansAction = createAsyncThunk(
  'learningPlan/getLearningPlansAction',
  async (
    { query, currentPage, pageSize, sortBy, orderBy },
    { rejectWithValue }
  ) => {
    try {
      let apiRoute = `/admin/learning-plans?currentPage=${currentPage}&pageSize=${pageSize}`;
      if (query) apiRoute += `&query=${query}`;
      if (sortBy) apiRoute += `&sortBy=${sortBy}`;
      if (orderBy) apiRoute += `&orderBy=${orderBy}`;

      const response = await axios.get(apiRoute);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const getLearningPlanAction = createAsyncThunk(
  'learningPlan/getLearningPlanAction',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/admin/learning-plans/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const createLearningPlanAction = createAsyncThunk(
  'learningPlan/createLearningPlanAction',
  async (learningPlanData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        '/admin/learning-plans',
        learningPlanData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const unbindClassFromLearningPlanAction = createAsyncThunk(
  'learningPlan/unbindClassFromLearningPlanAction',
  async ({ learningPlanId, classId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/admin/learning-plans/unbind/${learningPlanId}/classes/${classId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const updateLearningPlanAction = createAsyncThunk(
  'learningPlan/updateLearningPlanAction',
  async ({ id, learningPlanData }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `/admin/learning-plans/${id}`,
        learningPlanData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const deleteLearningPlanAction = createAsyncThunk(
  'learningPlan/deleteLearningPlanAction',
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`/admin/learning-plans/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
